<template>
  <div class="familyhistoryfeedback">

    <h1 id="formTitle">Family history research service corrections and feedback</h1>
    <!-- <ClosureNotice/> -->
    <p>The information on a historical record is what was correct at the time of event.</p>
    <p>Read our <a
        href="https://www.publications.qld.gov.au/dataset/rbdm-policies/resource/1c905c59-814e-4ad1-92c2-aa17e809fd84"
        target="_blank">corrections policy</a> and use this request form to: </p>
    <ul class="disc">
      <li>correct information copied into our historical index—we will only correct errors made by us when copying the
        information from a life event to our historical index</li>
      <li>make sure the record is the one you want to purchase</li>
      <li>give us feedback about the family history research service. </li>
    </ul>
    <p>After we have reviewed your request, we will let you know how we can help you.</p>
    <p>Find out how to <a href="https://www.familyhistory.bdm.qld.gov.au/orders/download/" target="_blank">download
        previously purchased images</a>.</p>
    <h2>Contact us</h2>
    <p>Fill in the details below and we will contact you within 10 business days.</p>
    <p>Before you start, read our <a
        href="https://www.publications.qld.gov.au/dataset/rbdm-policies/resource/1c905c59-814e-4ad1-92c2-aa17e809fd84"
        target="_blank">corrections policy</a></p>
    <form @submit="submitForm" id="submitForm">
      <ol class="questions">
        <li class="section">
          <fieldset>
            <legend>
              <span class="h3">Your contact details</span>
            </legend>
            <ul class="questions">
              <li>
                <label for="contactFirstName"> <span class="label">First name</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="contactFirstName" autocomplete="given-name" v-model="form.contactFirstName"
                  name="attributes.contactFirstName" type="text" required="required" class="stretchWidth" maxlength="512">
              </li>
              <li>
                <label for="contactFamilyName"> <span class="label">Family name</span> <abbr class="required"
                    title="(required)">*</abbr></label>
                <input id="contactFamilyName" autocomplete="family-name" v-model="form.contactFamilyName"
                  name="attributes.contactFamilyName" type="text" required="required" class="stretchWidth"
                  maxlength="512">
              </li>
              <li>
                <fieldset>
                  <ul class="questions compact">
                    <li class="applicantPreferredContactEmail">
                      <label for="applicantPreferredContactEmail">
                        <span class="label">Email</span>
                        <abbr class="required" title="(required)">*</abbr>
                        <small class="hint">We will notify you about your request by email. Please ensure this email
                          address is correct.</small>
                      </label>
                      <input id="applicantPreferredContactEmail" autocomplete="email"
                        v-model="form.applicantPreferredContactEmail" name="attributes.applicantPreferredContactEmail"
                        type="email" required="required" class="stretchWidth" maxlength="512">
                    </li>
                    <li class="applicantPreferredContactMobile">
                      <label for="applicantPreferredContactMobile">
                        <span class="label">Contact number</span>
                        <abbr class="required" title="(required)">*</abbr>
                        <small class="hint">If you do not have a mobile number, provide a daytime phone number.</small>
                      </label>
                      <input id="applicantPreferredContactMobile" autocomplete="tel"
                        v-model="form.applicantPreferredContactMobile" name="attributes.applicantPreferredContactMobile"
                        type="tel" pattern=".{10,}" required="required" class="stretchWidth" maxlength="15">
                    </li>
                  </ul>
                </fieldset>
              </li>
            </ul>
          </fieldset>
        </li>
        <li>
          <fieldset>
            <legend id="attributes.isHistoricalRecord">
              <span class="h3">Is the life event you want to contact us about a historical record?</span>
              <abbr class="required" title="(required)">*</abbr>
              <small class="hint">An entry in the online family history research service about a historical record.</small>
            </legend>
            <ul class="choices compact">
              <li>
                <input v-model="form.isHistoricalRecord" id="is-historical-record-yes" value="true" required="required"
                  name="is-historical-record" type="radio"><label for="is-historical-record-yes">Yes</label>
              </li>
              <li>
                <input v-model="form.isHistoricalRecord" id="is-historical-record-no" value="false" required="required"
                  name="is-historical-record" type="radio"><label for="is-historical-record-no">No</label>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.isHistoricalRecord == 'true'">
          <fieldset>
            <legend id="attributes.haveFeedback">
              <span class="h3">Do you have feedback about our family history research service?</span>
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <ul class="choices compact">
              <li>
                <input v-model="form.haveFeedback" id="have-feedback-yes" value="true" required="required"
                  name="have-feedback" type="radio"><label for="have-feedback-yes">Yes</label>
              </li>
              <li>
                <input v-model="form.haveFeedback" id="have-feedback-no" value="false" required="required"
                  name="have-feedback" type="radio"><label for="have-feedback-no">No</label>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.isHistoricalRecord == 'false'">
          <fieldset>
            <legend>
              <div class="status warn">
                <span class="h3">Don't use this form</span><br />
                <br />
                <p>We would like to help you with your enquiry, please complete our <a href="/#/generalenquiry">general
                    enquiry form</a>.</p>
              </div>
            </legend>
          </fieldset>
        </li>
        <li v-if="form.isHistoricalRecord == 'true' && (form.haveFeedback)">
          <fieldset>
            <legend id="attributes.consent">
              <abbr class="required" title="(required)">*</abbr>
            </legend>
            <ul class="choices">
              <li>
                <input v-model="form.consent" id="consent" value="true" required="required" name="consent"
                  type="checkbox"><label for="consent">By using the following online service and providing an email
                  address, I consent to the use of that email address for the Registry of Births, Deaths and Marriages
                  (RBDM) to provide me with correspondence that relates to this request. I understand that it is my
                  responsibility to ensure that I have nominated a secure email address for RBDM to send correspondence
                  to. I acknowledge that it is my responsibility to ensure the security of that information upon receipt
                  of it.</label>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.consent == true" class="section">
          <fieldset>
            <legend>
              <span class="h3">Details of life event to be reviewed</span>
              <span class="hint"><strong>Please note:</strong> when the review has been done a registry officer will
                contact you.</span>
            </legend>
            <ul class="questions">
              <li>
                <fieldset>
                  <legend id="attributes.eventType">
                    <abbr class="required" title="(required)">*</abbr>
                    <span>Type of life event to be reviewed</span>
                  </legend>
                </fieldset>
                <ul class="choices">
                  <li>
                    <input v-model="form.eventType" id="eventType-birth" value="Birth" required="required"
                      name="eventType" type="radio"><label for="eventType-birth">Birth</label>
                  </li>
                  <li>
                    <input v-model="form.eventType" id="eventType-marriage" value="Marriage" required="required"
                      name="eventType" type="radio"><label for="eventType-marriage">Marriage</label>
                  </li>
                  <li>
                    <input v-model="form.eventType" id="eventType-death" value="Death" required="required"
                      name="eventType" type="radio"><label for="eventType-death">Death</label>
                  </li>
                </ul>
              </li>
              <li>
                <fieldset>
                  <legend>
                    <span class="label">Name of person on the certificate</span>
                    <span class="hint">We only need the name of one partner for a marriage.</span>
                  </legend>
                  <ul class="questions">
                    <li>
                      <label for="certificateFirstName"> <span class="label">First name</span> <abbr class="required"
                          title="(required)">*</abbr></label>
                      <input id="certificateFirstName" autocomplete="given-name" v-model="form.certificateFirstName"
                        name="attributes.certificateFirstName" type="text" required="required" class="stretchWidth"
                        maxlength="512">
                    </li>
                    <li>
                      <label for="certificateMiddleName"> <span class="label">Middle name(s)</span></label>
                      <input id="certificateMiddleName" autocomplete="additional-name"
                        v-model="form.certificateMiddleName" name="attributes.certificateMiddleName" type="text"
                        class="stretchWidth" maxlength="512">
                    </li>
                    <li>
                      <label for="certificateFamilyName"> <span class="label">Family name</span> <abbr class="required"
                          title="(required)">*</abbr></label>
                      <input id="certificateFamilyName" autocomplete="family-name" v-model="form.certificateFamilyName"
                        name="attributes.certificateFamilyName" type="text" required="required" class="stretchWidth"
                        maxlength="512">
                    </li>
                    <li>
                      <label for="eventDate">
                        <span class="label">Date of event</span>
                        <abbr title="(required)" class="required">* </abbr>
                      </label>
                      <input id="eventDate" required="true" type="date" value="" size="10" v-model="form.eventDate"
                        name="attributes.eventDate" maxlength="10">
                    </li>
                    <li>
                      <label for="referenceNumber">
                        <span class="label">Registration number</span>
                        <span class="hint">If known.</span>
                      </label>
                      <input id="referenceNumber" type="text" value="" size="30" v-model="form.referenceNumber"
                        name="attributes.referenceNumber" maxlength="30">
                    </li>
                    <li>
                      <fieldset>
                        <legend id="attributes.actionType">
                          <span>Do you want to:</span>
                        </legend>
                      </fieldset>
                      <ul class="choices">
                        <li>
                          <input v-model="form.actionType" id="actionType-correct"
                            value="Correct information copied into historical index" name="actionType" type="radio"><label
                            for="actionType-correct">correct information copied into the historical index</label>
                        </li>
                        <li>
                          <input v-model="form.actionType" id="actionType-confirm" value="Confirm a record for purchase"
                            name="actionType" type="radio"><label for="actionType-confirm">make sure the record is the one
                            you want to purchase</label>
                        </li>
                      </ul>
                    </li>
                    <ul v-if="form.actionType == 'Correct information copied into historical index'" class="questions">
                      <li>
                        <label for="incorrectInformation">
                          <span class="label">What information is incorrect?</span>
                          <abbr title="(required)" class="required">* </abbr>
                          <span class="hint">Give us a brief idea of what is incorrect.</span>
                        </label>
                        <input id="incorrectInformation" required="required" type="text" value="" size="512"
                          v-model="form.incorrectInformation" name="attributes.incorrectInformation" maxlength="512">
                      </li>
                      <li>
                        <label for="informationToCorrect">
                          <span class="label">What is the correct information?</span>
                          <abbr title="(required)" class="required">* </abbr>
                          <span class="hint">Tell us what the correct information should be.</span>
                        </label>
                        <input id="informationToCorrect" required="required" type="text" value="" size="512"
                          v-model="form.informationToCorrect" name="attributes.informationToCorrect" maxlength="512">
                      </li>
                    </ul>
                    <li v-if="form.actionType == 'Confirm a record for purchase'">
                      <label for="confirmPurchase">
                        <span class="label">What additional details can you tell us to help search our system?</span>
                        <abbr title="(required)" class="required">* </abbr>
                        <span class="hint">Tell us more information about the person and the life event.</span>
                      </label>
                      <input id="confirmPurchase" required="required" type="text" value="" size="512"
                        v-model="form.confirmPurchase" name="attributes.confirmPurchase" maxlength="512">
                    </li>
                  </ul>
                </fieldset>
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.consent == true && form.haveFeedback == 'true'" class="section">
          <fieldset>
            <legend>
              <span class="h3">Feedback for the family history research service</span>
              <span class="hint"><strong>Please note:</strong> when your feedback has been reviewed a registry officer
                will contact you.</span>
            </legend>
            <ul class="questions">
              <li>
                <fieldset>
                  <legend id="attributes.suggestions">
                    <abbr class="required" title="(required)">*</abbr>
                    <span>Do you have suggestions that might improve our family history research service?</span>
                  </legend>
                </fieldset>
                <ul class="choices compact">
                  <li>
                    <input v-model="form.suggestions" id="suggestions-yes" value="true" required="required"
                      name="suggestions" type="radio"><label for="suggestions-yes">Yes</label>
                  </li>
                  <li>
                    <input v-model="form.suggestions" id="suggestions-no" value="false" required="required"
                      name="suggestions" type="radio"><label for="suggestions-no">No</label>
                  </li>
                </ul>
              </li>
              <li v-if="form.suggestions == 'true'">
                <label for="improveExperience">
                  <span class="label">How do you think your experience using our service could be improved?</span>
                  <abbr title="(required)" class="required">* </abbr>
                  <span class="hint">Give us a brief idea of how we might improve the service.</span>
                </label>
                <input id="improveExperience" required="required" type="text" value="" size="512"
                  v-model="form.improveExperience" name="attributes.improveExperience" maxlength="512">
              </li>
              <li v-if="form.suggestions == 'false'">
                <fieldset>
                  <legend id="attributes.technicalIssue">
                    <abbr class="required" title="(required)">*</abbr>
                    <span>Have you experienced a technical issue with the family history research service?</span>
                  </legend>
                </fieldset>
                <ul class="choices compact">
                  <li>
                    <input v-model="form.technicalIssue" id="technical-issue-yes" value="true" required="required"
                      name="technical-issue" type="radio"><label for="technical-issue-yes">Yes</label>
                  </li>
                  <li>
                    <input v-model="form.technicalIssue" id="technical-issue-no" value="false" required="required"
                      name="technical-issue" type="radio"><label for="technical-issue-no">No</label>
                  </li>
                </ul>
              </li>
              <li v-if="form.suggestions == 'false' && form.technicalIssue == 'true'">
                <fieldset>
                  <legend id="attributes.shoppingCart">
                    <abbr class="required" title="(required)">*</abbr>
                    <span>Was your shopping cart showing as empty?</span>
                  </legend>
                </fieldset>
                <ul class="choices compact">
                  <li>
                    <input v-model="form.shoppingCart" id="shopping-cart-yes" value="true" required="required"
                      name="shopping-cart" type="radio"><label for="shopping-cart-yes">Yes</label>
                  </li>
                  <li>
                    <input v-model="form.shoppingCart" id="shopping-cart-no" value="false" required="required"
                      name="shopping-cart" type="radio"><label for="shopping-cart-no">No</label>
                  </li>
                </ul>
              </li>
              <li v-if="form.suggestions == 'false' && form.technicalIssue == 'false'">
                <fieldset>
                  <legend>
                    <div class="status info">
                      <p>Please contact us using our <a href="/#/generalenquiry" target="_blank">general enquiry form</a>.
                      </p>
                    </div>
                  </legend>
                </fieldset>
              </li>
              <li v-if="form.suggestions == 'false' && form.technicalIssue == 'true' && form.shoppingCart == 'true'">
                <fieldset>
                  <legend>
                    <div class="status info">
                      <span class="h3">Shopping cart tip</span><br />
                      <p>Purchasing online is convenient. </p>
                      <p>However, keep in mind that the built-in settings, browser and history or cookies on your device
                        may create their own issues. </p>
                      <p>If you are getting a message that your shopping car is empty:</p>
                      <ul class="bullet">
                        <!-- extra li due to weird styling, doesn't seem like bullet points in status info supported very well in SWE -->
                        <li></li>
                        <li>select the green checkout button to continue</li>
                        <li>try a different internet browser</li>
                        <li>clear the browser history or cookies</li>
                        <li>use a different device.</li>
                      </ul>
                    </div>
                  </legend>
                </fieldset>
              </li>
              <li v-if="form.suggestions == 'false' && form.technicalIssue == 'true' && form.shoppingCart == 'false'">
                <label for="issueExperienced">
                  <span class="label">What issue are you experiencing with the family history research service?</span>
                  <abbr title="(required)" class="required">* </abbr>
                  <span class="hint">Provide details about the issue.</span>
                </label>
                <input id="issueExperienced" required="required" type="text" value="" size="512"
                  v-model="form.issueExperienced" name="attributes.issueExperienced" maxlength="512">
              </li>
            </ul>
          </fieldset>
        </li>
        <li v-if="form.consent == true">
          <UploadDocumentation v-model="uploads" max="6" />
        </li>
        <li id="inProgress">
          <p v-if="inProgress">Submitting your enquiry...</p>
          <p v-else> </p>
        </li>
        <li v-if="form.consent == true">
          <fieldset>
            <ul class="actions">
              <li>
                <strong><button :disabled="uploads.uploading > 0 || inProgress" id="submitButton">Submit
                    feedback</button></strong>
              </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
    <hr />
  </div>
</template>

<script>
import sppapi from '@/sppapi.js';
import UploadDocumentation from '../disasterrecovery/forms/UploadDocumentation.vue'
import ClosureNotice from '../ClosureNotice.vue';

export default {
  name: 'TheFamilyHistoryFeedbackForm',
  data: function () {
    return {
      acceptedTypes: '.jpg, .png, .jpeg, .pdf',
      processId: 'familyHistoryFeedback',
      form: {
        contactFirstName: '',
        contactFamilyName: '',
        applicantPreferredContactMobile: '',
        applicantPreferredContactEmail: '',
      },
      contactPhone: '',
      contactEmail: '',
      uploads: {
        uploadIds: [],
        uploading: 0,
        acceptedTypes: '.jpg, .tiff, .png, .jpeg, .pdf',
        supportingFiles: 1
      },
      inProgress: false,
    }
  },
  computed: {

  },
  methods: {
    removeUpload: function (event) {
      event.preventDefault()
      let targetUploadId = event.target.attributes['targetUpload'].value
      document.getElementById(targetUploadId).value = ''
      this.uploadIds = this.uploadIds.filter(uploadId => uploadId.fieldId !== targetUploadId)
      return false
    },
    uploadExists: function (fieldId) {
      return this.uploadIds.filter(uploadId => uploadId.fieldId == fieldId).length
    },
    submitForm: function (event) {
      event.preventDefault();
      this.contactPhone = this.form.applicantPreferredContactMobile;
      this.contactEmail = this.form.applicantPreferredContactEmail;

      if (!this.form.contactFirstName || !this.form.contactFamilyName) {
        return
      }

      if (this.form.applicantPreferredContactMobile.length < 10) {
        return
      }

      if (this.form.applicantPreferredContactEmail.length < 1) {
        return
      }

      if (!this.form.certificateFirstName || !this.form.certificateFamilyName) {
        return
      }

      sppapi.startProcessAndCompleteTask(this);
    }
  },
  components: {
    UploadDocumentation,
    ClosureNotice //eslint-disable-line  vue/no-unused-components
  }
}

</script>

<style scoped lang="scss">
#inProgress {
  height: 1em;
}

#uploading {
  height: 1em;
}

.applicantPreferredContactEmail {
  width: 100%;
}

#supportingDocumentationFiles td {
  padding: 0 0 1.2em 0;
  background: white;
}

#supportingDocumentationFiles th {
  display: none;
}

.removeUpload {
  cursor: pointer;
}

.bullet li {
  list-style: circle;
}

.disc li {
  list-style: disc;
}
</style>
